import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

import { MingaPermission } from 'libs/domain';
import { Observable } from 'rxjs';

import { PermissionsService } from '@app/src/app/permissions';

@Injectable()
export class MingaScheduledReportsGuard {
  constructor(private _permissionService: PermissionsService) {}
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    return this._permissionService.observePermission(MingaPermission.SCHEDULED_REPORTS_MANAGE);
  }
}
